<template>
    <div id="OrderModelContainer">
        <b-modal size="lg" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc 
            :title="TitleWindow" ref="modalAddGoals" @close="this.emitEventCancel" @ok="this.emitEventOK" ok-only :ok-title="$t('Shared.Close')" 
        > 
            <Loading v-bind:IsLoading="this.Load" />

            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">
                    <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                </div>
            </div>

            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="ViewReadOnly && !isReadOnly">
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">
                    <span>{{ $t('modalMarsMed.EmployeeMessageType') }}</span>
                </div>
            </div>

            <div class="IncidentContainerBox noNum mt-2">            
                <div class="row">
                    <div class="col-md-12">
                        <div class="grid-margin stretch-card">
                            <div class="card activeCard">
                                <div class="card-body">
                                    <div 
                                        class="d-flex align-items-start justify-content-between">
                                        <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate">
                                            {{PhotoObj.patientName}} - {{PatientCode}} - {{ $t('Shared.Dob') }} {{PhotoObj.dob}} {{PhotoObj.ageFormatted}} - {{$t('Shared.Weight')}} {{PhotoObj.weight}} - {{$t('Shared.Height')}} {{PhotoObj.heights}}</h6>
                                    </div>
                                    <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('modalMarsMed.clickTitleTextPatient')}}</small></b-collapse>
                                    <b-collapse id="InfoBoxs"> 
                                        <div class="card activeCard">			
                                            <div class="container-mars">
                                                <div class="card-container">
                                                    <div class="card-body">
                                                        <div class="row patPhoto-container">
                                                            <div class="col-md-1 patPhoto">

                                                                <i 
                                                                    id="rm-allergic" 
                                                                    v-if="PhotoObj.allergies && !PhotoObj.specialPrecautions" 
                                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies" 
                                                                    variant="primary">
                                                                </i>

                                                                <i 
                                                                    id="rm-allergic" 
                                                                    v-if="!PhotoObj.allergies && PhotoObj.specialPrecautions" 
                                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                                    v-b-tooltip.hover="`${$t('Shared.PatientSpecialPrecautions')}: `+PhotoObj.specialPrecautions" 
                                                                    variant="primary">
                                                                </i>

                                                                <i 
                                                                    id="rm-allergic" 
                                                                    v-if="PhotoObj.allergies && PhotoObj.specialPrecautions" 
                                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor" 
                                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies + ' / '+   `${$t('Shared.PatientSpecialPrecautions')}: `+PhotoObj.specialPrecautions + ` / ` + $t('Shared.MarsAlerts') +': '+ PhotoObj.marsAlerts" 
                                                                    variant="primary">
                                                                </i>

                                                                <img v-if="PhotoObj.patientPhoto" v-bind:src="'data:image/'+'.'+PhotoObj.patientPhotoExtension+';base64,'+PhotoObj.patientPhoto" alt="Foto" class="patPic img-fluid" style="height: 100%;">
                                                                <img v-if="(PhotoObj.patientPhoto === null || PhotoObj.patientPhoto === '') && PhotoObj.sex === 'Male'" src="@/assets/images/faces/nopic-male.jpg" alt="Foto" class="photo img-fluid">
                                                                <img v-if="(PhotoObj.patientPhoto === null || PhotoObj.patientPhoto === '') && PhotoObj.sex === 'Female'" src="@/assets/images/faces/nopic-female.jpg" alt="Foto" class="photo img-fluid">
                                                            </div>
                                                            <div class="col-md-11">
                                                                <div class="row">
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{ $t('Shared.PatientName') }}</small><br>
                                                                        <b>{{PhotoObj.patientName}}</b>
                                                                    </div>
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{ $t('Shared.PatientCode') }}</small><br>
                                                                        <b>{{PatientCode}}</b>
                                                                    </div>
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{ $t('Shared.Dob') }}</small><br>
                                                                        <b>{{PhotoObj.dob}}</b>
                                                                    </div>
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{ $t('Shared.Age') }}</small><br>
                                                                        <b>{{PhotoObj.ageFormatted}}</b>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{ $t('Shared.Gender') }}</small><br>
                                                                        <b>{{PhotoObj.sex}}</b>
                                                                    </div>
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{$t('Shared.Weight')}}</small><br>
                                                                        <b>{{PhotoObj.weight}}</b>
                                                                    </div>
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{$t('Shared.Height')}}</small><br>
                                                                        <b>{{PhotoObj.heights}}</b>
                                                                    </div>
                                                                    <div class="col-md-3 text-muted p-item">
                                                                        <small>{{$tc('Shared.Program')}}</small><br>
                                                                        <b>{{PhotoObj.programName}}</b>
                                                                    </div>                                                    
                                                                </div>
                                                            </div>
                                                        </div>                   
                                                    </div>
                                                </div>
                                            </div>    
                                        </div>
                                
                                        <div class="row mt-2"> 
                                            <MdPatientAllergies
                                                v-bind:NoUseClass="false"               
                                                v-bind:ModalIdAddAllergy="'AddAllergyMars'"
                                                v-bind:VisibleAllergy="true"                    
                                                v-bind:UseColumnDinamic="true"
                                                v-bind:Column="'col-md-4'"                   
                                                v-bind:PatientCode="PatientCode.trim()"
                                                v-bind:NoValidateChanges="true">						
                                            </MdPatientAllergies> 
                                            <MdPatientSpecialPrecautions	
                                                v-bind:NoUseClass="false"                
                                                v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMarsMed'"                   
                                                v-bind:VisibleSpecialPrecautions="true"
                                                v-bind:UseColumnDinamic="true"
                                                v-bind:Column="'col-md-4'"
                                                v-bind:PatientCode="PatientCode.trim()"
                                                v-bind:NoValidateChanges="true">						
                                            </MdPatientSpecialPrecautions> 
                                            <MdPatientDiagnosis v-if="true"
                                                v-bind:UseColumnDinamic="true"
                                                v-bind:VisibleDiagnosis="true"
                                                v-bind:ModalIdDiagnosis="'ModalIdDiagMarsMed'"
                                                v-bind:Column="'col-md-4'"
                                                v-bind:PatientCode="PatientCode.trim()">						
                                            </MdPatientDiagnosis>
                                        </div>               
                                    </b-collapse>
                                </div> 
                            </div>                
                        </div>                 
                    </div>                     
                </div>                
            </div>

            <b-row class="mt-2">
                <b-col md="2" sm="12">               
                    <MdEdit 
                        v-bind:Label="$t('Nurses.DateTimeFrom')" 
                        v-bind:isReadOnly="ViewReadOnly || isReadOnly"                     
                        v-bind:TypeProp="'datetime-local'" 
                        v-bind:Name="'DateFrom'"										
						v-bind:Id="'input_date_from'"
                        v-bind:NoValidateChanges="true"
                        v-bind:Min="'1900-01-01T00:00'"
                        v-bind:OnPressEnter="getListing"
                        v-bind:isRequired="true"
                        v-bind:isValid="IsValidDateandTimeFrom"    
                        v-on:blur="getListing"                     
                        v-bind:Max="'2200-12-31T23:59'"                         
                        v-model="DateFromModal"/>        
                </b-col>
                <b-col md="2" sm="12">            
                    <MdEdit 
                        v-bind:Label="$t('Nurses.DateTimeTo')"  
                        v-bind:isReadOnly="ViewReadOnly || isReadOnly"                    
                        v-bind:TypeProp="'datetime-local'"  
                        v-bind:isRequired="true"
                        v-bind:NoValidateChanges="true"
                        v-bind:OnPressEnter="getListing"
                        v-on:blur="getListing"
                        v-bind:isValid="IsValidDateandTimeTo" 
                        v-bind:Min="'1900-01-01T00:00'"
                        v-bind:Max="'2200-12-31T23:59'"                        
                        v-model="DateToModal"/>  
                </b-col>
                <b-col md="2">
                    <MdSelect
                        v-bind:Label="$t('Shared.Type')"                   
                        v-bind:Options="ModeList"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"
                        v-bind:Tag="'TarsOrderModalType'"
                        v-bind:NoValidateChanges="true"
                        v-bind:AllowEmpty="false"
                        v-bind:Model="mode"                       
                        v-bind:Multiple="false"
                        v-bind:IsDisabled="ViewReadOnly || isReadOnly"
                        :Input="ChangeDropDownMode"                   
                    />
                </b-col>
                <b-col md="2">
                    <MdSelect
                        v-bind:Label="$t('Shared.Status')"                   
                        v-bind:Options="StatusList"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"   
                        v-bind:AllowEmpty="false"
                        v-bind:RequireEvent="true"                
                        v-bind:Model="Status" 
                        v-bind:IsDisabled="ViewReadOnly || isReadOnly || isTypePRN"
                        :Input="ChangeDropDownStatus"                   
                    />
                </b-col>

                <b-col md="3">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input type="text" class="form-control" :dir="dirInput" v-model="parameter.SearchCriteria" :readonly="ViewReadOnly || isReadOnly"
                                @keyup.enter="GetOrders">
            
                            <div class="input-group-append">
                                <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'" v-on:click="GetOrders" v-bind:isReadOnly="ViewReadOnly || isReadOnly">
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </b-col>

                <b-col lg="1" md="1" sm="12" class="align-self-end mb-2">
                    <button 
                        :disabled="isReadOnly || ViewReadOnly"
                        v-on:click="SearchOrder"
                        type="button"
                        class="btn btn-primary btn-login"												
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}
                    </button>
                </b-col>       
            </b-row>

            <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <div v-if="showEmptyRecords" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite"><div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div></div>

            <b-alert show class="alert alert-fill-warning" v-if="isAllergic()">
                <h5 class="alert-heading mt-2">
                    <i class="mdi mdi-alert me-2" style="font-size: 1.5rem;"></i>
                    <span>{{$t('Shared.Alert')}}<span class="d-none d-sm-inline"> {{$t('modalTarsOrder.FoundOrder')}}</span>!</span>
                </h5>
                <hr>
                <ul class="ml-2">
                    <li v-for="(item, index) in getAllergies()" :key="index">{{item}}</li>
                </ul>
            </b-alert>

            <div class="zebraAccordion">
                <div class="zebraRow" v-for="(item, index) in OrderList" :key="index">
                    <div class="accordion" role="tablist" >  
                        <div class="zebraItem" v-b-toggle="'accordion-'+index">
                            <div class="container-fluid">
                                <div class="row d-flex justify-content-between align-items-center">
                                    <div class="col-md-11">
                                        <div class="d-flex align-items-center">                           
                                            <span v-if="HaveOneGiven(index)"><i class="ikon med-adm-given greenIconColorHeader h3" v-b-tooltip.hover :title="$t('modalMarsMed.Given')"></i></span>
                                            <span v-if="HaveOneNoGiven(index) && !HaveOneGiven(index)"><i class="ikon med-adm-not-given redIconColorHeader h3" v-b-tooltip.hover :title="$t('modalMarsMed.NoGiven')"></i></span>                         
                                            <span :disabled="isReadOnly" v-if="GivenNeutro(index) && !item.needAssessment"> <i  v-bind:class="{ 'ikon med-adm-not-selected': !item.isHovered, 'ikon med-adm-given': item.isHovered,'ikon h3 silverIconColorHeader':((item.mode !== 'PRN' && item.tarsAdministrations[0].expiredAdministration) || item.mode === 'PRN') || isReadOnly || ViewReadOnly ,'ikon h3 quickSave':((item.mode !== 'PRN' && !item.tarsAdministrations[0].expiredAdministration) || item.mode === 'PRN') && !isReadOnly && !ViewReadOnly}"
                                                @mouseover="IsHover(true,index)"
                                                :style="(item.mode !== 'PRN' && item.tarsAdministrations[0].expiredAdministration) || isReadOnly || ViewReadOnly ? 'pointer-events:NONE;' :''"
                                                @mouseout="IsHover(false,index)" v-on:click="SaveAuto($event,item)"></i>
                                            </span>
                                            <span v-if="GivenNeutro(index) && item.needAssessment"><i class="ikon med-adm-not-selected silverIconColorHeader ikon h3" v-b-tooltip.hover :title="$t('modalMarsMed.Neutral')"></i></span>
                                            <span class="mx-2"><span>{{ item.orderName }}<br><small class="ml-2">{{ item.adminDate }} <span class="PRNlabel" v-if="item.mode === 'PRN'" v-b-tooltip.hover title="Pro Re Nata (as needed)">PRN</span> <span v-if="item.mode === 'TIMED'"><span class="opAT">@</span> {{item.adminTime}}</span><span class="blinkingSTAT" v-if="item.mode === 'STAT'">STAT</span>  </small></span></span>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="pull-right">
                                            <i :class=" 
                                                getStatus(item.mode,index) === '4_NO_PEND_ADM' ? 'ikon med-adm-not-pending silverIconColorHeader h3' 
                                                :getStatus(item.mode,index) === '3_PRIOR_TO_ADM' ? 'ikon med-adm-prior greenIconColorHeader h3'
                                                :getStatus(item.mode,index) === '2_CLOSE_TO_ADM' ? 'ikon med-adm-close orangeIconColorHeader h3'
                                                : 'ikon med-adm-overdue redIconColorHeader h3'" v-b-tooltip.hover :title="getTitle(item.mode,index)">
                                            </i>                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-card no-body>
                            <b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="accordionContent pt-3">   
                                    <div class="card activeCard">
                                        <div class="container-mars mt-3">
                                            <div class="card-container">
                                                <div class="card-body">
                                                    <div class="row patPhoto-container">
                                                        <div class="col-md-2 patPhoto">
                                                            <i 
                                                                id="rm-allergic" 
                                                                v-if="PhotoObj.allergies && !PhotoObj.specialPrecautions" 
                                                                class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor" 
                                                                v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies" 
                                                                variant="primary">
                                                            </i>

                                                            <i 
                                                                id="rm-allergic" 
                                                                v-if="!PhotoObj.allergies && PhotoObj.specialPrecautions" 
                                                                class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor" 
                                                                v-b-tooltip.hover="`${$t('Shared.PatientSpecialPrecautions')}: `+PhotoObj.specialPrecautions" 
                                                                variant="primary">
                                                            </i>

                                                            <i 
                                                                id="rm-allergic" 
                                                                v-if="PhotoObj.allergies && PhotoObj.specialPrecautions" 
                                                                class="mdi mdi-alert text-warning allergies relocateIconMed helpCursor" 
                                                                v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies + ` / ` + $t('Shared.PatientSpecialPrecautions') +': '+ PhotoObj.specialPrecautions" 
                                                                variant="primary">
                                                            </i> 
                                                        </div>

                                                        <div class="col-md-12 resetFontSize">
                                                            <div class="row">
                                                                <div class="col-md-9 text-muted p-item" v-if="item.prescriberNotes">
                                                                    <small>{{$t('Shared.PrescriberNotes')}}</small><br>
                                                                    <b>{{ item.prescriberNotes }}</b>
                                                                </div>
                                                                <div class="col-md-9 text-muted p-item" v-else>
                                                                    <small>{{$t('Shared.PrescriberNotes')}}</small><br>
                                                                    <b>{{$t('Shared.Notdefined')}}</b>
                                                                </div>   

                                                                <div class="col-md-3 text-muted p-item" v-if="item.orderByName">
                                                                    <small>{{$t('Shared.Prescriber')}} </small><br>
                                                                    <b>{{ item.orderByName }}</b>
                                                                </div>
                                                                <div class="col-md-3 text-muted p-item" v-else>
                                                                    <small>{{$t('Shared.Prescriber')}} </small><br>
                                                                    <b>{{$t('Shared.Notdefined')}}</b>
                                                                </div>                                                   
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-for="(itemchild,indexchild) in item.tarsAdministrations" v-bind:key="GetItemChildPrefix(item, itemchild)" > 
                                        <b-button-group class="ml-3 groupActions whiteBtn" v-if="item.mode === 'PRN'">
                                            <b-button  v-b-tooltip.hover
                                                :disabled="isReadOnly || ViewReadOnly || pendingChanges"
                                                v-on:click="AddAdm(item)"
                                                :title="$t('modalMarsMed.AddAdm')" size="sm" variant="light">
                                                <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                        
                                            <b-button  v-b-tooltip.hover
                                                v-on:click="DeleteAdm(item,itemchild,indexchild)"
                                                :disabled="isReadOnly || ViewReadOnly || !(itemchild.isNewAdm && item.tarsAdministrations.length > 1)"
                                                :title="$t('modalMarsMed.DelAdm')" size="sm" variant="light">
                                                <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                        </b-button-group>
                                        
                                        <b-card bg-variant="white">
                                            <b-row v-if="item.needAssessment">  
                                                <b-col md="12">
                                                    <div class="alert alert-fill-warning d-flex flex-column flex-md-row align-items-center m-2" role="alert">
                                                        <i class="ikon med-adm-not-selected me-2" style="font-size: 1.5rem;"></i>
                                                        <div class="flex-grow-1 d-flex flex-column align-items-center align-items-md-start text-center text-md-left">
                                                            <span v-if="item.needAssessment"> {{$t('modalMarsMed.Assessment') }}</span>
                                                        </div>
                                                        <b-dropdown id="dropdown-right" :text="$t('modalMarsMed.Assess')" variant="primary" class="mt-2 mt-md-0 ms-md-auto">
                                                            <b-dropdown-item 
                                                                :disabled="isReadOnly"
                                                                v-for="(assessmentItem, assessmentIndex) in itemchild.assessmentDetails"
                                                                :key="assessmentItem.templateCode + assessmentIndex"
                                                                v-bind:value="assessmentItem.templateCode"
                                                                v-on:click="showModalOutCome(assessmentItem, item, itemchild, index, indexchild, assessmentIndex)"
                                                            >
                                                                <div v-if="assessmentItem.metAssessment">
                                                                    <i class="ikon med-status-complete h3" v-b-tooltip.hover :title="$t('modalMarsMed.AssessmentCompleted')"></i> {{assessmentItem.templateDescription}}
                                                                </div>
                                                                <div v-else>
                                                                    <i class="ikon med-pen h3" v-b-tooltip.hover :title="$t('modalMarsMed.AssessmentNotCompleted')"></i> {{assessmentItem.templateDescription}}
                                                                </div>
                                                            </b-dropdown-item>
                                                        </b-dropdown>
                                                    </div>
                                                </b-col>
                                            </b-row>

                                            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="itemchild.expiredAdministration">
                                                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                                                <div class="flex-grow-1">
                                                    <span>{{ $t('modalMarsMed.ExpiredAdministration') }}</span>
                                                </div>
                                            </div>

                                            <b-row>  
                                                <b-col md="2" class=" align-self-center text-center">                      
                                                    <b-button-toolbar class="mt-2">
                                                        <b-button-group class="mr-1 giveMeds">

                                                            <b-tooltip :target="'GivenId'+index"  placement="top" :delay="{ show: 500, hide: 0 }">
                                                                {{$t('modalMarsMed.Given')}}
                                                            </b-tooltip>

                                                            <b-tooltip :target="'UndoGivenId'+index"  placement="top" :delay="{ show: 500, hide: 0 }">
                                                                {{$t('modalMarsMed.UndoGive')}}
                                                            </b-tooltip>

                                                            <b-tooltip :target="'UndoNoGiveId'+index"  placement="top" :delay="{ show: 500, hide: 0 }">
                                                                {{$t('modalMarsMed.UndoNoGive')}}
                                                            </b-tooltip>

                                                            <b-tooltip :target="'NoGivenId'+index"  placement="top" :delay="{ show: 500, hide: 0 }">
                                                                {{$t('modalMarsMed.NoGiven')}}
                                                            </b-tooltip>

                                                            <span :id="'GivenId'+index"  class="d-inline-block" tabindex="0">
                                                                    <b-button id="GivenId" :disabled="isReadOnly || itemchild.disabledGiven || itemchild.given || itemchild.expiredAdministration || ViewReadOnly || !VerifyAllAssessment(item,itemchild.assessmentDetails)" 
                                                                        v-if="itemchild.given === null || itemchild.given" v-on:click="Give(item,itemchild,index,indexchild)" class="greenMed"
                                                                    >
                                                                        <i class="ikon med-adm-given"></i>
                                                                    </b-button>
                                                            </span>
                                                            <span :id="'UndoGivenId'+index" class="d-inline-block" tabindex="0">
                                                                    <b-button :disabled="isReadOnly || ViewReadOnly || !VerifyAllAssessment(item,itemchild.assessmentDetails)" 
                                                                    v-if="itemchild.given !== null && itemchild.given"  v-on:click="NoGiveUndo(item,itemchild,index,indexchild)" class="redMed undoMedRight" 
                                                                    >
                                                                        <i class="ikon med-adm-undo"></i>
                                                                    </b-button>
                                                            </span>
                                                            <span :id="'UndoNoGiveId'+index" class="d-inline-block" tabindex="0">
                                                                    <b-button :disabled="isReadOnly || ViewReadOnly" 
                                                                    v-if="itemchild.given !== null && !itemchild.given" v-on:click="GiveUndo(item,itemchild,index,indexchild)" class="greenMed undoMedLeft" 
                                                                    >
                                                                        <i class="ikon med-adm-undo"></i>
                                                                    </b-button>     
                                                            </span>                     
                                                            <span :id="'NoGivenId'+index" class="d-inline-block" tabindex="0">
                                                                    <b-button :disabled="isReadOnly || itemchild.disabledNoGiven || itemchild.given === false || ViewReadOnly" 
                                                                    v-if="itemchild.given === null || !itemchild.given" v-on:click="NoGive(item,itemchild,index,indexchild)" class="redMed" 
                                                                    >
                                                                        <i class="ikon med-adm-not-given"></i>
                                                                    </b-button>
                                                            </span>

                                                        </b-button-group> 
                                                    </b-button-toolbar>
                                                </b-col>                 

                                                <b-col md="4">
                                                    <MdEdit 
                                                        v-bind:Label="$t('Shared.GivenTime')"
                                                        v-bind:TypeProp="'time'"
                                                        v-bind:IdButton="'btn_givenTime_'+GetItemChildPrefix(item, itemchild)"
                                                        v-bind:Name="'givenTime_'+GetItemChildPrefix(item, itemchild)" 
                                                        v-bind:Obj1="itemchild"
                                                        v-bind:isReadOnly="isReadOnly  || ViewReadOnly || itemchild.given == null"
                                                        v-bind:Id="'givenTime_'+GetItemChildPrefix(item, itemchild)"
                                                        :ref="'givenTime_'+GetItemChildPrefix(item, itemchild)"
                                                        v-model="itemchild.givenTime">                                     
                                                    </MdEdit>
                                                </b-col>         

                                                <b-col md="3" v-show="itemchild.given === false">
                                                    <MdSelect
                                                        v-bind:Label="$t('modalMarsMed.AdministrationStatus')"
                                                        data-field="therapistcode"
                                                        v-bind:Options="ReasonList"
                                                        v-bind:IdButton="'btn_save_tarsadm'+GetItemChildPrefix(item, itemchild)"
                                                        v-bind:FieldDescription="'name'"
                                                        v-bind:FieldCode="'code'"
                                                        :IsDisabled="/*(item.needAssessment && !VerifyAllAssessment(item,itemchild.assessmentDetails)) ||*/ (itemchild.given) || isReadOnly || ViewReadOnly /*|| !pendingChanges*/"
                                                        v-bind:Model="itemchild.reasonCodeModel" 
                                                        v-bind:UseParamsAux="true"
                                                        v-bind:UseResetModel="true"
                                                        v-bind:AuxParam="itemchild"                                 
                                                        :Input="ChangeDropDownReason"
                                                        v-bind:Name="'reasonCodeModel_'+GetItemChildPrefix(item, itemchild)"
                                                        :ref="'reasonCodeModel_'+GetItemChildPrefix(item, itemchild)"
                                                    />

                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col md="12">
                                                    <div :data-label="$t('modalMarsMed.AdministrationNotes')" class="textlabel"></div>
                                                    <MdMemo         
                                                        v-bind:TypeProp="'text'" 
                                                        v-bind:Name="'administrationNotes_'+GetItemChildPrefix(item, itemchild)"
                                                        v-bind:Obj1="itemchild"
                                                        v-bind:IdButton="'btn_notes_tarsadm'+GetItemChildPrefix(item, itemchild)"
                                                        v-bind:Rows="'3'"
                                                        v-bind:isReadOnly="isReadOnly  || ViewReadOnly || itemchild.given == null"
                                                        v-bind:MaxRows="'6'" 
                                                        v-model="itemchild.administrationNotes"
                                                        v-bind:Tag="'administrationNotes'">                                     
                                                    </MdMemo>
                                                </b-col>
                                            </b-row>

                                            <b-row>                   
                                                <b-col md="12" class="mt-3 text-right">
                                                    <MdButton
                                                        v-on:click="SaveAdministration(item,itemchild)"
                                                        v-bind:isReadOnly="(isReadOnly  || ViewReadOnly || itemchild.given === null || itemchild.DisaBledBtnAdm) "
                                                        v-bind:Label="$t('modalMarsMed.Administration')"                      
                                                        v-bind:Name="'btn_save_tarsadm'+GetItemChildPrefix(item, itemchild)"
                                                        v-bind:ClassProp="'secondary mx-2 btn-login'" 
                                                    />
                                                </b-col>
                                            </b-row>

                                            <br v-if="(itemchild.reviewedByName && itemchild.reviewedByName.trim() !== '') || (itemchild.reviewedOn && itemchild.reviewedOn.trim() !== '')">
                                            <div class="mt-2" v-if="(itemchild.reviewedByName && itemchild.reviewedByName.trim() !== '') || (itemchild.reviewedOn && itemchild.reviewedOn.trim() !== '')">
                                                <div class="d-sm-flex justify-content-center justify-content-sm-between">
                                                    <span class="text-muted text-center italic text-sm-left d-block d-sm-inline-block">
                                                        <span>{{$t('modalMarsMed.ReviewedByName')}}:</span> <b>{{itemchild.reviewedByName}}</b>
                                                        /// <span>{{$t('modalMarsMed.ReviewedOn')}}:</span> <b>{{itemchild.reviewedOn}}</b>
                                                    </span>                       
                                                </div>
                                            </div>

                                        </b-card>
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
            </div>


            <div class="row mt-4" dir="ltr">
                <div class="my-1 col-sm-7 col-md-6">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        @change="onChange"
                        pills
                        size="lg"
                    ></b-pagination>
                </div>
                <div align="right" class="mr-2 col">
                    {{ $t('Shared.Show') }}
                    <b-form-select 
                        v-model="perPage" 
                        :options="options" 
                        size="sm" 
                        id="perPageSelect"
                        v-bind:style="perPageStyle"
                        @change="perPageChange">
                    </b-form-select>
                    {{ $t('Shared.Of') }} {{totalRows}}
                </div>
            </div>

            <MdPasswordDlg v-if="showSignPassword" 
                v-bind:Type="'Sign'"
                v-bind:Obj1="Obj1"
                v-bind:Obj2="Obj2"
                v-bind:EmployeeCode="this.$store.state.employeeCode"
                @getModalPassword="onModalPasswordResult($event)">
            </MdPasswordDlg>

            <MdPatientVitalSingOutCome v-if="activeModalVitalSign"
                v-bind:ModalId="PatientVitalId"
                v-bind:PatientCode="this.PatientCode"
                v-bind:TitleWindow="outComeTitle"
                v-bind:outComeCode="outComeCode"
                v-bind:MarsParam="TarsParam"
                v-bind:ForUsefromMars="true"
                v-bind:ComponentKind="'Memo'"
                v-bind:NotOpenByDefault="false"
                @getCodeConditionOK="onCodeConditionOk($event)"
                @getCancel="onCancel($event)">
            </MdPatientVitalSingOutCome>

            <MdGenericOutCome v-if="activateModalGeneric"
                v-bind:ModalId="GenericId"
                v-bind:TitleWindow="outComeTitle"
                v-bind:NotOpenByDefault="false"
                v-bind:ForUsefromMars="true"
                v-bind:MarsParam="TarsParam"
                v-bind:outComeCode="outComeCode"
                v-bind:outComeDescription="outComeDescription"
                @getCodeConditionOK="onCodeConditionOk($event)"
                @getCancel="onCancel($event)">
            </MdGenericOutCome>

            <MdPatientAllergiesOutCome v-if="activateModalAllergies"
                v-bind:ModalId="AllergyId"
                v-bind:PatientCode="this.PatientCode"
                v-bind:NotOpenByDefault="false"
                v-bind:ForUsefromMars="true"
                v-bind:outComeCode="outComeCode"
                v-bind:MarsParam="TarsParam"
                v-bind:TitleWindow="outComeTitle"
                @getCodeConditionOK="onCodeConditionOk($event)"
                @getCancel="onCancel($event)">
            </MdPatientAllergiesOutCome>

            <MdPainAssessmentModalListing v-if="activateModalPainAssessmentList"
                v-bind:ModalId="AssessmentModalId"
                v-bind:RecordId="RecordId"
                v-bind:PatientCode="this.PatientCode"
                v-bind:NotOpenByDefault="false"
                v-bind:outComeCode="outComeCode"
                v-bind:ForUsefromMars="true"
                v-bind:MarsParam="TarsParam"
                v-bind:TitleWindow="outComeTitle"
                @getCodeConditionOK="onCodeConditionOk($event)"
                @getCancel="onCancel($event)">
            </MdPainAssessmentModalListing>
        </b-modal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import Loading from '@/components/template/loading/Loading'
import Utils from "@/common/utils"
import TarsService from '@/services/tars.service'
import ReasonService from '@/services/reason.service'
import EmployeeService from '@/services/employee.service'
import GlobalService from '@/services/global.service'
import PhysiciansOrdersOptionsService from '@/services/physiciansordersoptions.service'
import { EventBus } from '@/event-bus.js';

let elemSaveBtn = '';
export default {
    name: 'TarsOrderModal',
    mixins: [ShowMessage],  
    props: {
        ModalId: String,
        TitleWindow: String,
        PatientCode:String,
        DateFrom:String,
        DateTo:String,  
        PhotoObj:Object,  
    },
    components: {
        Loading
    },

    data() {
        return {
            isReadOnly: false,
            ViewReadOnly:false,
            IsValidDateandTimeFrom:true,
            Load:false,
            perPage: 10,
            countAlerts:0,      
            totalRows: 0, 
            currentPage: 1,   
            showEmptyRecords:false,
            DateFromModal:this.DateFrom,
            DateToModal:this.DateTo,
            unitSys: 'U',
            parameter:{  
                DateTimeFrom:null,
                DateTimeTo:null,       
                PatientList:[],
                LevelList:[],
                BuildingList:[],
                RoomList:[],
                ProgramList:[],
                SearchCriteria:null,
                PageSize:10,
                PageNumber:1
            },
            IsValidDateandTimeTo:true,
            ModeList:[{code:"",name:"ALL"},{code:"TIMED",name:"TIMED"},{code:"PRN",name:"PRN"}],
            mode:{code:"TIMED",name:"TIMED"},
                emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },
            OrderList:[],
            OrderListCopy: [],
            perPageStyle: {
                width: 'auto'
            },
            options: [
                { value: 5, text: '5' },
                { value: 10, text: '10' },
                { value: 15, text: '15' },
            ],
            ReasonList:[],
            TypeList:['N','T','M'],
            TarsParam:{
                indexParent:null,
                indexAdministracion:null,
                indexAssessment:null,
            },  
            Obj1:{},
            Obj2:{},
            outComeTitle:"Assessments",
            outComeDescription:"",
            outComeCode:"",
            AssessmentModalId:"TarsMedicationModalPainAssessmentList",
            PainAssessmentId:"TarsMedicationModalPainAssessment",
            InsuranceId:"TarsMedicationModalInsurance",
            PatientVitalId:"TarsMedicationModalPatientVital",
            GenericId:"TarsMedicationModalGeneric",
            DiagCodeId:"TarsMedicationModalDiagCodes",
            AllergyId:"TarsMedicationModalAllergy",
            ContactId:"TarsMedicationModalContact",
            activeModalVitalSign:false,
            activateModalGeneric:false,
            activateModalAllergies:false,
            activateModalPainAssessmentList:false,
            showSignPassword:false,
            PhysiciansOrdersOptions: {},
            StatusList:[
                {code:null,name:"All"},
                {code:"Given",name:"Given"},
                {code:"NoGiven",name:"No Given"},
                {code:"PendingToGive",name:"Pending To Give"}      
            ],
            Status:{code:"PendingToGive",name:"Pending To Give"},
            isTypePRN:false,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    }, 

    methods: {
        emitEventCancel(event){
            if (this.pendingChanges) {
                event.preventDefault();
                this.handleVerifyAndClose();
            } else {
                this.$emit('ModalTPTarsOrder');
            }
        }, 

        onCancel(){
            this.deActivateModal();
        },   

        emitEventOK(event){
            if (this.pendingChanges) {
                event.preventDefault();
                this.handleVerifyAndClose();
            } else {
                this.$emit('ModalTPTarsOrder');
            }
        },

        handleVerifyAndClose() {
            this.$bvModal
                .msgBoxConfirm(this.$t('modalMarsMed.LeavingWithoutSaving'), {
                    title: this.TitleWindow,
                    okTitle: this.$t('Shared.TitleYes'),
                    cancelTitle: this.$t('Shared.TitleNo'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if(value){
                        this.$emit('ModalTPTarsOrder');
                        this.$nextTick(() => {
                            this.$bvModal.hide(this.ModalId);
                        });
                    }
                });
        },

        ChangeDropDownMode(item){
            this.mode = item ? item : {code:"",name:"ALL"};
            if(this.mode.code === 'PRN'){
                this.Status.code = null;
                this.Status.name = "All";
                EventBus.$emit('ChangedDrop', {model:this.Status,Tag:"TarsOrderModalType"});
                this.isTypePRN = true;
            }else{
                this.isTypePRN = false;
            }
            this.GetOrders();
        },

        ChangeDropDownStatus(item){       
            this.Status.code = item.code;
            this.Status.name = item.name;      
            this.GetOrders();
        },

        checkUserAction(IdButton) {      
            elemSaveBtn = document.getElementById(IdButton);            
            if (elemSaveBtn !== null && elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        DisabledBtn(){
            setTimeout(() =>this.DisabledAllButtons(), 1500); 
        },

        DisabledAllButtons(){
            for(var i = 0; i < this.MedList.length; i++){
                let arrMarsAdm = this.MedList[i].tarsAdministrations;

                for(var j = 0; j < arrMarsAdm.length; j++){           
                    let elbtn = document.getElementById('btn_save_tarsadm'+this.GetItemChildPrefix(this.MedList[i], arrMarsAdm[j]));
                    elbtn.setAttribute('disabled','');
                }
            }
        },

        onChange(page) {      
            this.currentPage = page;   
            this.GetOrders();  
        },

        perPageChange(value) {
            this.perPage = value;  
            this.currentPage = 1;   
            this.GetOrders();
        },

        getTitle(mode,index){
            let statusTranslated = "";
            if(mode === 'PRN'){           
                statusTranslated = this.$t('modalMarsMed.NoPendAdm');
            }else{
                statusTranslated = this.OrderList[index].tarsAdministrations[0].administrationStatusTranslated;
            }
            return statusTranslated;
        },

        getListing() {
            this.GetOrders();
        },

        async GetOrders() {
            if (this.pendingChanges) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('modalMarsMed.ChangingWithoutSaving'), {
                        title: this.TitleWindow,
                        okTitle: this.$t('Shared.TitleYes'),
                        cancelTitle: this.$t('Shared.TitleNo'),
                        footerClass: 'p-2',
                        titleClass: 'modal-title modal-type-warning'
                    })
                    .then(async value => {
                        if(value){
                            this.GetOrdersAsync();
                        }
                    })	
            } else {
                await this.GetOrdersAsync();
            }
        },

        async GetOrdersAsync() {
            if (this.validate_required()) {
                if (Utils.ValidateDate(this.DateFromModal, Utils.getDateTimeFormatToIso()) && Utils.ValidateDate(this.DateToModal, Utils.getDateTimeFormatToIso())){      
                    this.OrderList = []; 
                    this.Load = true;       
                    let param = {  
                        Mode:this.mode.code,             
                        PatientCode :this.PatientCode,
                        SearchCriteria:this.parameter.SearchCriteria,
                        DateFrom:this.DateFromModal,
                        DateTo:this.DateToModal,          
                        PageNumber : this.currentPage,
                        PageSize : this.perPage,
                        Status:this.Status.code,
                    };
                    await TarsService.getOrderListing(param)
                        .then((response) => {
                            if (response.status == '200' && response.data) {
                                this.OrderList = response.data;
                                this.showEmptyRecords = response.data && response.data.length === 0 ? true : false;                   
                                this.totalRows = response.data.length > 0 ? response.data[0].maxRows : 0;  
                                this.OrderList.forEach(function(element) {  
                                    element.isHovered = false;
                                    element.tarsAdministrations.forEach(function(item) {
                                        item.reasonCodeModel = this.ReasonList.find(x => x.code == item.reasonCode);
                                    }, this);

                                    if (element.adminDate)	
                                        element.adminDate = Utils.formatterDateToString(element.adminDate);                            
                                    if (element.adminTime)	
                                        element.adminTime = Utils.formatTime(element.adminTime); 
                                    if (element.dateTimeExpired)
                                        element.dateTimeExpired = Utils.formatterDateTimeToString(element.dateTimeExpired);
                                    
                                    if(element.mode === 'PRN'){
                                        for(var i = 0; i < element.assessmentTypes.length; i++){
                                            element.assessmentTypes[i].metAssessment = false;
                                        }  
                                    }
                                }, this);

                                setTimeout(() => {
                                    this.OrderList.forEach(function(element) {
                                        if(element.mode === 'PRN') {
                                            element.tarsAdministrations.unshift(
                                            {
                                                isNewAdm:true,
                                                administrationNotes:"",
                                                administrationStatus: "",
                                                administrationStatusTranslated:"",
                                                expiredAdministration:false,
                                                given:null,
                                                givenDate:null,
                                                givenTime:null,
                                                tarsRecNo:null,
                                                assessmentDetails:element.assessmentTypes,
                                                metAssessment:true,
                                                reasonCode:null,
                                                reasonDescription:null,
                                                reviewedByName:"",
                                                reviewedOn:null,
                                                signed:true,     
                                                reason: {code:"",name:""},
                                                reasonCodeModel: null,
                                                lastGiven: null
                                            });
                                        }
                                    }, this);
                                }, 10, this);

                                this.PopulateUndoAdm();           
                            }
                            
                            this.Load = false;
                            this.pendingChanges = false;
                        })
                        .catch(error => {
                            this.Load = false;
                            this.showResponseErrorMessage(error);
                        });
            
                    }else{
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.ITime'),"error");
                    }
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('modalMarsMed.DateFromToRequired'), "errorAutoHide");    
            }
        },

        SearchOrder() {
            this.GetOrders();
        },

        validate_required(){
            this.IsValidDateandTimeFrom = this.DateFromModal ? true : false;
            this.IsValidDateandTimeTo = this.DateToModal ? true : false;        
            return this.IsValidDateandTimeFrom  && this.IsValidDateandTimeTo; 
        },

        HaveOneGiven(index){
            let count = 0; 
            let arr = this.OrderList[index].tarsAdministrations;
            for(var i = 0; i < arr.length; i++){
                if(arr[i].lastGiven !== null && arr[i].lastGiven){
                    count++;
                }
            }        
            return count > 0;
        },

        HaveOneNoGiven(index){
            let count = 0; 
            let arr = this.OrderList[index].tarsAdministrations;
            for(var i = 0; i < arr.length; i++){
                if(arr[i].lastGiven !== null && !arr[i].lastGiven){
                    count++;
                }
            }        
            return count > 0;
        },

        GivenNeutro(index){
            let count = 0; 
            let arr = this.OrderList[index].tarsAdministrations;
            for(var i = 0; i < arr.length; i++){
                if(arr[i].lastGiven === null){
                    count++;
                }
            }        
            return count === arr.length;
        },

        getStatus(mode,index){
            let status = "";
            if(mode === 'PRN'){
                status = "4_NO_PEND_ADM";
            }else{
                status = this.OrderList[index].tarsAdministrations[0].administrationStatus;
            }
            return status;
        },

        ChangeDropDownReason(value,itemchild){   
            itemchild.reason.code = value ? value.code : null; 
            itemchild.reason.name = value ? value.name : null; 
            itemchild.reasonCode = value ? value.code : null;
            itemchild.reasonCodeModel = value;
            setTimeout(() => {
                itemchild.DisaBledBtnAdm = false;
            }, 10);
        },

        PopulateUndoAdm(){
            for(var i = 0; i < this.OrderList.length; i++){
                let arr = this.OrderList[i].tarsAdministrations;
                arr.forEach(function(element) { 
                    element.DisaBledBtnAdm = true; 
                    element.disabledGiven = false;
                    element.administrationNotes = element.administrationNotes === null ? "" :element.administrationNotes;
                    element.disabledNoGiven = false;
                    element.givenTime = element.givenTime ? Utils.formatterTimeToString(element.givenTime) /*Utils.formatterDateTimeToString(element.givenTime)*/ : null;
                    element.reviewedOn = element.reviewedOn ? Utils.formatterDateTimeToString(element.reviewedOn) : null;         
                    element.reasonCodeModel = this.ReasonList.find(x => x.code == element.reasonCode);
                    element.reason = {code:element.reasonCode,name:element.reasonDescription};
                    element.lastGiven = element.given;
                }, this)
            }   
            this.OrderListCopy = [...this.OrderList];
        },

        async Give(item,itemchild,index,indexChild){ 
            itemchild.disabledGiven = true;
            itemchild.DisaBledBtnAdm = false;   
            if(item.needAssessment){
                if(this.VerifyAllAssessment(item,itemchild.assessmentDetails)){               
                    await this.getDateTime();   
                    this.OrderList = [];
                    this.OrderListCopy[index].tarsAdministrations[indexChild].given = true;               
                    this.OrderListCopy[index].tarsAdministrations[indexChild].givenTime = this.DateTimeNow; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCode = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCodeModel = null;
                    this.OrderListCopy[index].tarsAdministrations[indexChild].administrationNotes = '';
                    this.OrderList = [...this.OrderListCopy];
                    this.pendingChanges = true;
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('modalMarsMed.NeedAssessment'),"error");
                }
            } else {
                    await this.getDateTime();   
                    this.OrderList = [];
                    this.OrderListCopy[index].tarsAdministrations[indexChild].given = true; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].givenTime = this.DateTimeNow; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCode = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCodeModel = null;
                    this.OrderListCopy[index].tarsAdministrations[indexChild].administrationNotes = '';
                    this.OrderList = [...this.OrderListCopy];
                    this.pendingChanges = true;
            }     
        },

        async NoGive(item,itemchild,index,indexChild){ 
            itemchild.disabledNoGiven = true; 
            itemchild.DisaBledBtnAdm = false;                
            await this.getDateTime(itemchild); 
            this.OrderList = [];
            this.OrderListCopy[index].tarsAdministrations[indexChild].given = false; 
            this.OrderListCopy[index].tarsAdministrations[indexChild].givenTime = this.DateTimeNow; 
            this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCodeModel = null;
            this.OrderListCopy[index].tarsAdministrations[indexChild].administrationNotes = '';
            this.OrderList = [...this.OrderListCopy];
            this.pendingChanges = true;
        },

        GiveUndo(item,itemchild,index,indexChild){     
            itemchild.disabledNoGiven = false;  
            itemchild.DisaBledBtnAdm = false;    
            this.OrderList = [];
            this.OrderListCopy[index].tarsAdministrations[indexChild].given = null; 
            this.OrderListCopy[index].tarsAdministrations[indexChild].givenTime = null; 
            this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCode = null; 
            this.OrderListCopy[index].tarsAdministrations[indexChild].reason = {code:"",name:""};  
            this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCodeModel = null;    
            this.OrderListCopy[index].tarsAdministrations[indexChild].administrationNotes = '';        
            this.OrderList = [...this.OrderListCopy];  
            this.pendingChanges = true;    
            EventBus.$emit('OnResetModelSelect'); 
        },

        NoGiveUndo(item,itemchild,index,indexChild){
            itemchild.disabledGiven = false;  
            itemchild.DisaBledBtnAdm = false;    
            if(item.needAssessment){
                if(this.VerifyAllAssessment(item,itemchild.assessmentDetails)){             
                    this.OrderList = [];
                    this.OrderListCopy[index].tarsAdministrations[indexChild].given = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].givenTime = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCode = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reason = {code:"",name:""};       
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCodeModel = null;         
                    this.OrderListCopy[index].tarsAdministrations[indexChild].administrationNotes = '';
                    this.OrderList = [...this.OrderListCopy];  
                    this.pendingChanges = true; 
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('modalMarsMed.NeedAssessment'),"error");
                }
            } else {         
                    this.OrderList = [];
                    this.OrderListCopy[index].tarsAdministrations[indexChild].given = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].givenTime = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCode = null; 
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reason = {code:"",name:""};     
                    this.OrderListCopy[index].tarsAdministrations[indexChild].reasonCodeModel = null;      
                    this.OrderListCopy[index].tarsAdministrations[indexChild].administrationNotes = '';     
                    this.OrderList = [...this.OrderListCopy];   
                    this.pendingChanges = true;
            }    
            
            EventBus.$emit('OnResetModelSelect'); 
        },

        AddAdm(item){       
            item.tarsAdministrations.unshift(
            {  
                isNewAdm:true,
                administrationNotes:"",
                administrationStatus: "",
                administrationStatusTranslated:"",
                expiredAdministration:false,
                given:null,
                givenDate:item.adminDate,
                assessmentDetails:item.assessmentTypes,
                givenTime:null,
                tarsRecNo:null,
                metAssessment:false,
                reasonCode:null,
                reasonDescription:null,
                reviewedByName:"",
                reviewedOn:null,
                signed:false,
                reason: {code:"",name:""},
                reasonCodeModel:null,
                lastGiven:null
            });
        },

        DeleteAdm(item,itemchild,indexchild){       
            if(itemchild.isNewAdm && item.tarsAdministrations.length > 1){         
                item.tarsAdministrations.splice(indexchild, 1);
                this.OrderList = [];
                this.OrderList = [...this.OrderListCopy];
            }
        },

        VerifyAllAssessment(item,arr){
            let count = 0; 
            if(item.needAssessment){
                arr.forEach(function(element) {
                if(element.metAssessment){
                    count++;
                    }
                })   
                return count === arr.length;
            }  
            return true;        
        },

        showModalOutCome(assessmentItem,item,itemchild,index,indexchild,assessmentIndex){       
            this.TarsParam.indexParent = index;           
            this.TarsParam.indexAdministracion = indexchild; 
            this.TarsParam.indexAssessment =  assessmentIndex;        
            if(assessmentItem.templateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES'){  
                this.outComeCode = assessmentItem.testCode;  
                this.RecordId =  item.recordId;
                this.activateModalPainAssessmentList = true; 
            }
            else if(assessmentItem.templateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES'){ 
                this.outComeCode = assessmentItem.testCode;  
                this.activeModalVitalSign = true;
            }
            else if(assessmentItem.templateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES'){ 
                this.outComeCode = assessmentItem.testCode; 
                this.activateModalGeneric = true;
            }   
            else if(assessmentItem.templateCode.toUpperCase() === 'TFRMALLERGIESEHR'){   
                this.outComeCode = assessmentItem.testCode;          
                this.activateModalAllergies = true;            
            }
        },

        deActivateModal(/*item*/){
            this.activeModalVitalSign = false;
            this.activateModalGeneric = false;
            this.activateModalAllergies = false;
            this.activateModalPainAssessmentList = false;
        },

        onCodeConditionOk(result){        
            let info = result.info;
            if(info !== null || info !== ""){
                let admin = result.MarsParam;
                this.OrderList = [];               
                this.OrderListCopy[admin.indexParent].tarsAdministrations[admin.indexAdministracion].administrationNotes += info+"\n";                
                this.OrderList = [...this.OrderListCopy];  
                
                this.DoAssess(admin.indexParent,admin.indexAdministracion,admin.indexAssessment);  
            }      
        
            this.deActivateModal()
        },

        DoAssess(index, indexChild,assessmentIndex){            
            this.OrderList = [];
            this.OrderListCopy[index].tarsAdministrations[indexChild].assessmentDetails[assessmentIndex].metAssessment = true; 
            this.OrderList = [...this.OrderListCopy];       
        },

        onModalPasswordResult(result){ 
            let item = result.Obj1;
            let itemchild = result.Obj2;

            if(result.type === 'Sign'){
                if(result.status !== true) {           
                    this.showMessage(this.$tc('Msg.Error'),result.message,"error");                       
                }else{   
                    this.$store.commit('setWrotePasswordTars',true);   

                    item.tarsAdministrations[item.tarsAdministrations.length-1].given = true;    
                    item.tarsAdministrations[item.tarsAdministrations.length-1].givenTime =  this.DateTimeNow;       
                    
                    if(itemchild.recNo){            
                        this.UpdateAdministration(item,itemchild);              
                    }else{
                        if(item.mode === 'PRN'){
                            this.InsertAdministration(item,itemchild);
                        }else{
                            this.UpdateAdministration(item,itemchild);
                        } 
                    }
                }
            }

            this.showSignPassword = false;   
        },

        SaveAdministration(item,itemchild){
            this.Obj1 = item;
            this.Obj2 = itemchild;      
            if(this.PhysiciansOrdersOptions.byPassPhysicianSignature){
                if(itemchild.recNo){
                    this.UpdateAdministration(item,itemchild);
                }else{
                    if(item.mode === 'PRN'){
                        this.InsertAdministration(item,itemchild);
                    }else{                   
                        this.UpdateAdministration(item,itemchild);
                    } 
                }
            }else{  
                if(this.$store.state.alreadyWrotePasswordTars){
                    if(itemchild.recNo){
                        this.UpdateAdministration(item,itemchild);
                    }else{
                    if(item.mode === 'PRN'){
                        this.InsertAdministration(item,itemchild);
                    }else{                   
                        this.UpdateAdministration(item,itemchild);
                    } 
                }
                }else{
                    this.showSignPassword = true;
                }  
            }
        },

        UpdateAdministration(item,itemchild){
            if (!this.validateItemChild(item, itemchild)) {
                return;
            }

            let gtime =  Utils.CombineDateAndTime(Utils.toDate(item.adminDate, Utils.getDateTimeFormat()), Utils.toDate(itemchild.givenTime, 'HH:mm')); //itemchild.givenTime ? Utils.formatterToISO(itemchild.givenTime, Utils.getDateTimeFormat()): null ;  
            let param = {
                RecordId:item.recordId,
                Given:itemchild.given,
                GivenTime: gtime,
                TestCodes:this.getTestCodesCompleted(item,itemchild),
                ReasonCode:itemchild.reasonCode,
                AdministrationNotes:itemchild.administrationNotes,
                Signed:true,
                MetAssessment:true
            }        
        
            if(this.PhysiciansOrdersOptions.byPassPhysicianSignature){
                param.Signed = true;
            }

            this.Load = true;         
            TarsService.update(itemchild.recNo, param)
                    .then((response) => {             
                            if(response.status == '200'){
                                this.pendingChanges = false;
                                itemchild.DisaBledBtnAdm = true;                       
                                itemchild.reviewedByName = response.data.reviewedByName;
                                itemchild.reviewedOn = response.data.reviewedOn ? Utils.formatterDateTimeToString(response.data.reviewedOn):null;
                                itemchild.lastGiven = param.Given; 
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });

                                this.GetOrders();
                            }
                            this.Load = false;
                    })
                    .catch((error) => {
                        this.Load = false;
                        itemchild.DisaBledBtnAdm = false;
                        this.showResponseErrorMessage(error);       
                    });
        },

        async InsertAdministration(item,itemchild,isAuto){  
            if (!this.validateItemChild(item, itemchild)) {
                return;
            }

            let gtime =  Utils.CombineDateAndTime(Utils.toDate(item.adminDate, Utils.getDateTimeFormat()), Utils.toDate(itemchild.givenTime, 'HH:mm')); //itemchild.givenTime ? Utils.formatterToISO(itemchild.givenTime, Utils.getDateTimeFormat()): null ; 
            let param = {
                AdminDate:item.adminDate ? Utils.formatterToISO(item.adminDate, Utils.getDateTimeFormat()) : null,
                RecordId:item.recordId,
                AdmissionRecordId:item.admissionRecordId,
                Given:itemchild.given,
                GivenTime:gtime,
                ReasonCode:itemchild.reasonCode,
                AdministrationNotes:itemchild.administrationNotes,
                NeedAssessment:item.needAssessment,
                TestCodes:this.getTestCodesCompleted(item,itemchild),
                Signed:true,
                MetAssessment:true
            }

            if(this.PhysiciansOrdersOptions.byPassPhysicianSignature){
                param.Signed = true;
            }
            
            this.Load = true;      
            await TarsService.add(param)
                    .then((response) => {             
                        if(response.status == '200'){
                            this.pendingChanges = false;
                            itemchild.DisaBledBtnAdm = true;
                            itemchild.recNo = response.data.recNo;
                            itemchild.reviewedByName = response.data.reviewedByName;
                            itemchild.reviewedOn = response.data.reviewedOn ? Utils.formatterDateTimeToString(response.data.reviewedOn):null;
                            itemchild.lastGiven = param.Given;
                            this.InsertStatus = true;                           
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            });

                            this.GetOrders();
                        }else{
                            this.InsertStatus = false;
                        }               
                        this.Load = false;
                    })
                    .catch((error) => {
                        if(isAuto){
                            itemchild.given = null;    
                            itemchild.givenTime = null;  
                        }

                        this.InsertStatus = false;
                        itemchild.DisaBledBtnAdm = false;          
                        this.Load = false;
                        this.showResponseErrorMessage(error);         
                    });
        },

        async SaveAuto(e,item){     
            e.stopPropagation();
            await this.getDateTime(); 
            this.Obj1 = item;
            this.Obj2 = item.tarsAdministrations[item.tarsAdministrations.length-1];  

            if(this.PhysiciansOrdersOptions.byPassPhysicianSignature){
                if(item.mode === 'PRN'){  
                    e.stopPropagation(); 
                    item.tarsAdministrations[item.tarsAdministrations.length-1].given = true;    
                    item.tarsAdministrations[item.tarsAdministrations.length-1].givenTime =  this.DateTimeNow;       
                    await this.InsertAdministration(item,item.tarsAdministrations[item.tarsAdministrations.length-1],true);  
                    if(this.InsertStatus){               
                        this.AddAdm(item);
                        this.InsertStatus = false;
                    }  
                } else {       
                    e.stopPropagation();  
                    item.tarsAdministrations[item.tarsAdministrations.length-1].given = true;    
                    item.tarsAdministrations[item.tarsAdministrations.length-1].givenTime =  this.DateTimeNow;       
                    await this.UpdateAdministration(item,item.tarsAdministrations[0]);
                }
            }else{
                if(this.$store.state.alreadyWrotePasswordTars){
                    if(item.mode === 'PRN'){  
                        e.stopPropagation(); 
                        item.tarsAdministrations[item.tarsAdministrations.length-1].given = true;    
                        item.tarsAdministrations[item.tarsAdministrations.length-1].givenTime =  this.DateTimeNow;       
                        await this.InsertAdministration(item,item.tarsAdministrations[item.tarsAdministrations.length-1],true);  
                        if(this.InsertStatus){               
                            this.AddAdm(item);
                            this.InsertStatus = false;
                        }  
                    }else{       
                        e.stopPropagation();  
                        item.tarsAdministrations[item.tarsAdministrations.length-1].given = true;    
                        item.tarsAdministrations[item.tarsAdministrations.length-1].givenTime =  this.DateTimeNow;       
                        await this.UpdateAdministration(item,item.tarsAdministrations[0]);
                    }
                }else{
                    e.stopPropagation(); 
                    this.showSignPassword = true;
                }
            }
        },

        validateItemChild(item,itemchild) {
            let reasonCodeModelValid = true;
            let givenTimeValid = true;
            
            if(itemchild.given === false && (itemchild.reasonCode === null || itemchild.reasonCode === "") ) {
                reasonCodeModelValid = false;
                this.showMessage(this.$tc('Msg.Error'),this.$t('modalMarsMed.ReasonNoSelected'),"error");
            } 
            
            if(itemchild.givenTime === null || itemchild.givenTime === ""){
                givenTimeValid = false;
                this.showMessage(this.$tc('Msg.Error'),this.$t('modalMarsMed.GivenTimeError'),"error");
            } else if(!Utils.isValidTime(itemchild.givenTime)){
                givenTimeValid = false;
                this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.ITime'),"error");
            } else if (itemchild.given && Utils.toMidnight(item.adminDate, Utils.getDateTimeFormat()) > Utils.toMidnight(this.DateNow, Utils.getShortDateFormat())) {
                givenTimeValid = false;
                this.showMessage(this.$tc('Msg.Error'),this.$t('modalMarsMed.InvalidLaterDate'),"error");
            }

            this.$refs[`reasonCodeModel_${this.GetItemChildPrefix(item, itemchild)}`][0].setValid(reasonCodeModelValid);
            this.$refs[`givenTime_${this.GetItemChildPrefix(item, itemchild)}`][0].setValid(givenTimeValid);

            return givenTimeValid && reasonCodeModelValid;
        },

        isAllergic() {
            return this.OrderList.some(x => x.allergic && x.mode == 'TIMED');
        },

        getAllergies() {
            const order = this.OrderList.find(x => x.allergic && x.mode == 'TIMED');
            if (order) {
                return order.allergies;
            }

            return [];
        },

        getTestCodesCompleted(item,itemchild){
            let result = [];
            if(item.needAssessment){
                let arr = itemchild.assessmentDetails;           
                for(var i = 0; i < arr.length; i++){
                    if(arr[i].metAssessment){
                        result.push(arr[i].testCode);
                    }
                }
                return result;
            }

            return result;
        },

        getReason() { 
            ReasonService.getReasonTars()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.ReasonList = response.data;             
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        GetItemChildPrefix(item, itemChild) {
            if (itemChild.recNo) {
                return `RC${itemChild.recNo}`;
            }

            const index = this.OrderList.indexOf(item);
            const childIndex = item.tarsAdministrations.indexOf(itemChild);
            return `II${index}_CI${childIndex}`;
        },

        async EmployeeCanChange(){
            var parameter = { 
                TypeList:this.TypeList,              
                Code:this.$store.state.employeeCode,
                Active:true
            };
            await EmployeeService.EmployeeCanChangesinView(parameter)
                .then((response) => {
                    if (response.status == '200' && response.data) {                                    
                        this.ViewReadOnly = response.data.length === 0 ? true :false;                                                       
                    }              
                }).catch(error => { 
                    this.showResponseErrorMessage(error);
                });
        },

        async getDateTime() { 
            await GlobalService.getDateTime()
                .then((response) => {      
                if (response.data) {                                  
                        this.DateTimeNow = Utils.formatterTimeToString(response.data); //Utils.formatterDateTimeToString(response.data);     
                        this.DateNow = Utils.formatterDateToString(response.data);                
                }  
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            }); 
        },

        async getPhysiciansOrdersOptions(){                 
            await PhysiciansOrdersOptionsService.getPhysiciansOrdersOptions()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){                
                        this.PhysiciansOrdersOptions = response.data[0];  
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);        
                });        
        },
    },

    async mounted() {
        this.Load = true;
        this.disableAddAllergies = this.$store.state.isUsePatientAllergies;
        this.isReadOnly = this.$store.state.isTarsEHRReadOnly;
        await Promise
                    .allSettled([await this.getReason(), this.getPhysiciansOrdersOptions(), this.EmployeeCanChange(), await this.getDateTime()])
                    .then(async (result) => {
                        result.length == 4 ? await this.GetOrders() : null
                    })
                    .catch((error) => {
                        this.Load = false;
                        this.showResponseErrorMessage(error);
                    });

        let arr = this.OrderList;
        let thats = this
        setTimeout( function() {       
            for(var i = 0; i < arr.length; i++){
                let arrTarsAdm = arr[i].tarsAdministrations;

                for(var j = 0; j < arrTarsAdm.length; j++){
                    let elbtn = document.getElementById('btn_save_tarsadm'+ thats.GetItemChildPrefix(arr[i], arrTarsAdm[j]));
                    elbtn.setAttribute('disabled','');
                }
            }
        }, 50,this);
    }
}
</script>

<style scoped>

.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.no-image {
  text-align: center;
  font-size: 18px;
  color: #ffffff;
}

.carouselPic{
    background-color: #FFF !important;
    border-radius: 15px 15px 0 0;
    border: 4px solid #19BEE1;
    overflow: hidden;
}
.carouselPic .carousel-item{
    background-color: #FFF !important;
}
.patPhoto .carousel-description{
    color: white !important;
    background-color: #19BEE1;
    border-radius: 0 0 15px 15px;
    height: 40px;
}
.patPhoto .carousel-description p{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 1;
    font-size: small;
    padding: 2px 10px 2px 10px;
}
.relocateIcon{
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed{
    position: absolute;
    top: 5px;
    right: 25px;
}

.medAdminLabel{
    padding: 0 0.8em;
    display: inline-block;
    margin-top: .4em;
    border-radius: 10px;
    font-variant-caps: all-small-caps;
    vertical-align: top !important;
    font-kerning: 5em;
    font-weight: bold;
    font-size: 0.8em;
    color: #FFF;
}
.allergicToMed{
    background-color: #F00;
    color: #FF9;
    animation: blinking 1s linear infinite;
}
.overdue{
    background-color: var(--overdue);
}
.close-to-admin{
    background-color: var(--close-to-admin);
}
.prior-to-admin{
    background-color: var(--prior-to-admin);
}
.no-pending{
    background-color: var(--no-pending);
}

@keyframes blinking {
    0%, 50% {
        color: #FF9;
    }
    100% {
        color: #F00;
    }
}
@keyframes fadingNow {
    0%, 50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.withDot::after{
    content: "●";
    color: #F00;
    position: absolute;
    top: 4px;
    left: 14px;
    animation: fadingNow 1s infinite;
}
.greenBTN{
    background-color: #0C0 !important;
    border-radius: 15px 0 0 15px !important;
    color: #6F6 !important;
}
.greenBTN:hover{
    background-color: #0F0 !important;
    box-shadow: 0 0 5px #008300;
    color: #FFF !important;
    transform: scale(1.1);
}
.redBTN{
    background-color: #C00 !important;
    border-radius: 0 15px 15px 0 !important;
    color: #F66 !important;
}
.redBTN:hover{
    background-color: #F00 !important;
    box-shadow: 0 0 5px #820000;
    color: #FFF !important;
    transform: scale(1.1);
}

/* MODAL REMAKE */
.zebraAccordion{
    margin: 0 1em;
}
.resetFontSize small{
    font-size: .95em;
}
.zebraAccordion .zebraRow .zebraItem{
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem{
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem{
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19BEE1;
    color: #FFF;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #FFF;
}
.zItemIcon{
    width: 15%;
    margin: 0 1%;
    display: inline;
    vertical-align: middle;
}

.zItemText{
    width: 86%;
    display: inline;
    vertical-align: middle;
}
@media (max-width: 992px) {
    .zItemIcon{
        width: 10%;
    }
    .zItemText{
        width: 75%;
    }
}
.quickSave{
    color: #19BEE1;
    transition: all .3s ease-in-out;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.quickSave:hover{
    color: #FFF;
}
.zebraAccordion .zebraRow .zebraItem small{
    font-size: .7em;
}
.PRNlabel{
    background-color: #6F6;
    border-radius: 10px;
    padding: 0 10px;
    color: #060 !important;
    transition: all .3s ease-in-out;
}
.PRNlabel:hover{
    background-color: #FF9;
}
.opAT{
    opacity: .5;
}
.accordionContent{
    border-top: 0;
    background: linear-gradient(173deg, #D9F4FB, #FFF 30% );
    padding-top: 3em;
}

.giveMeds button{
    border: 4px solid #FFFFFFEE;
    transition: all .3s ease-in-out;
    cursor: pointer;
}
.redMed{
    border-radius: 0 50px 50px 0;
    border-left: 0;
    height: 50px;
    background-color: #660000;
    background: linear-gradient(-40deg, #FF0000, #660000);
    animation: spreadShadowLast 1s ease-in-out infinite;
}
.redMed:hover{
    background-color: #FF0000;
    background: linear-gradient(-40deg, #990000, #FF0000);
}
.redMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.greenMed{
    border-radius: 50px 0 0 50px;   
    background-color: #008236;
    height: 50px;
    background: linear-gradient(-40deg, #008236, #003300);
    border-right: 0 !important;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.greenMed i::before{
    font-size: 1.1em;
}
.greenMed:hover{
    background-color: #00CC00;
    background: linear-gradient(-40deg, #006600,#01d85b);
}
.greenMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.GivNeutral{
    opacity: 0.2;
}

.undoMedLeft{
    background-color: #666;
    background: linear-gradient(-40deg, #EEE, #CCC);
    border: 4px solid #EEE !important;
    border-right: 0 !important;
}
.undoMedLeft:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #999, #CCC);
}
.undoMedRight{
    background-color: #666;
    background: linear-gradient(-40deg, #CCC, #EEE);
    border: 4px solid #EEE !important;
    border-left: 0 !important;
}
.undoMedRight:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #CCC, #999);
}
@keyframes spreadShadow {
    0%, 100% {
        text-shadow: 0 0 1px #00000099;
    }
    50% {
        text-shadow: 0 0 20px #000000FF;
    }
}
@keyframes spreadShadowFirst {
    0%, 100% {
        text-shadow: 0 0 1px #FFFFFF;
    }
    50% {
        text-shadow: 0 0 20px #FFFFFF;
    }
}
@keyframes spreadShadowLast {
    0%, 100% {
        text-shadow: 0 0 20px #FFFFFF, 0 0 20px #FFFFFF;
    }
    25% {
        text-shadow: 0 0 1px #FFFFFF, 0 0 1px #FFFFFF;
    }
}
.justSTAT{
    color: #FFF;
    background-color: #bcd9e0;
    border-radius: 10px;
    padding: 0 5px;
}
.blinkingSTAT{
    color: #FF0;
    background-color: #C00;
    border-radius: 10px;
    padding: 0 5px;
    animation: blinkSTAT 1s steps(5, start) infinite;
}

.custom-carousel .carousel-control-prev,
.custom-carousel .carousel-control-next {
  display: v-bind(showArrows ? 'block' : 'none');
}

@keyframes blinkSTAT {
to {
    visibility: hidden;
    }
}

</style>